import { style } from "@vanilla-extract/css";
import { breakpoints, vars } from "plos/src/styles";
import { tableStyles } from "../../../../../styles/sharedTableStyles.css";
import { leaguesTableCol } from "../../../shared";

export const standingsClassicTableWrapper = style({
  position: "relative",
  overflow: "auto",
  fontSize: vars.fontSizes.body.s,
});

export const standingsClassicTable = style([
  tableStyles,
  {
    "@media": {
      [`screen and (min-width:${breakpoints[1]})`]: {
        tableLayout: "fixed",
      },
    },
  },
]);

export const managerCol = style([
  leaguesTableCol,
  {
    "@media": {
      [`screen and (min-width:${breakpoints[4]})`]: {
        width: "70%",
      },
    },
  },
]);

export const rankCell = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space["2xs"],
});

export const entryLink = style({
  textDecoration: "none",
  color: "inherit",
});
